module.exports = __webpack_public_path__ + "@/assets/img/btn-windows.c077aa94.svg";